export { default as BackgroundColorWrapper } from './BackgroundColorWrapper';
